// GRNRoutesXL - Sprint 44 Fase 3 Vista 9.
import { Routes, Route } from 'react-router-dom';
import GRNListXL from './GRNListXL';
import GRNFormXL from './GRNFormXL';

export default function GRNRoutesXL() {
  return (
    <Routes>
      <Route index element={<GRNListXL />} />
      <Route path="create" element={<GRNFormXL />} />
      <Route path=":id/edit" element={<GRNFormXL />} />
    </Routes>
  );
}
